import PlansManager from './PlansManager'

const PlansList = () => {
  return <PlansManager isModal={false} />
}

export default PlansList
